import { getMap } from "../GeoLiteMap";

const pixelRatio = window.devicePixelRatio;

export const getSnapshot = (width = 100, height = 100): string => {
    const mapCanvas = document.createElement("canvas");

    const [mapWidth, mapHeight] = getMap().getSize();
    const useHeight = mapWidth > mapHeight;
    const sx = useHeight ? (mapWidth - mapHeight) / 2 : 0;
    const sy = useHeight ? 0 : (mapHeight - mapWidth) / 2;
    const swh = useHeight ? mapHeight : mapWidth;

    mapCanvas.width = width;
    mapCanvas.height = height;
    const mapContext = mapCanvas.getContext("2d");
    Array.prototype.forEach.call(document.querySelectorAll(".ol-layer canvas"), (canvas) => {
        if (canvas.width > 0) {
            const opacity = canvas.parentNode.style.opacity;
            mapContext.globalAlpha = opacity === "" ? 1 : Number(opacity);
            const transform = canvas.style.transform;
            // Get the transform parameters from the style's transform matrix
            const matrix = transform
                .match(/^matrix\(([^\(]*)\)$/)[1]
                .split(",")
                .map(Number);
            // Apply the transform to the export map context
            CanvasRenderingContext2D.prototype.setTransform.apply(mapContext, matrix);
            mapContext.drawImage(canvas, sx, sy, swh, swh, 0, 0, width * pixelRatio, height * pixelRatio);
        }
    });

    return mapCanvas.toDataURL();
};
